const PATH_PREFIX = '/admin/keepital';

export default [
  // Admin
  // QR Codes
  {
    name: 'keepital.qr_codes',
    path: `${PATH_PREFIX}/codes/qrcodes`,
  },
  {
    name: 'keepital.qr_code_details',
    path: `${PATH_PREFIX}/codes/qrcodes/:codeID/detail`,
  },
  // Announces
  {
    name: 'keepital.announce.categories',
    path: `${PATH_PREFIX}/announce/:type/categories`,
  },
  {
    name: 'keepital.announce.category',
    path: `${PATH_PREFIX}/announce/:type/category/:categoryID`,
  },
  {
    name: 'keepital.announce.articles',
    path: `${PATH_PREFIX}/announce/:type/articles`,
  },
  {
    name: 'keepital.announce.article.detail',
    path: `${PATH_PREFIX}/announce/:type/article/:docID`,
  },
  // Homepage
  {
    name: 'keepital.pages.home.banner.list',
    path: `${PATH_PREFIX}/pages/home/banners`,
  },
  {
    name: 'keepital.pages.home.banner.details',
    path: `${PATH_PREFIX}/pages/home/banner/:docID`,
  },
  {
    name: 'keepital.pages.home.category.list',
    path: `${PATH_PREFIX}/pages/home/categories`,
  },
  {
    name: 'keepital.pages.home.category.details',
    path: `${PATH_PREFIX}/pages/home/category/:docID`,
  },
  // Corporate Pages
  {
    name: 'keepital.pages.articles',
    path: `${PATH_PREFIX}/pages/:type`,
  },
  {
    name: 'keepital.pages.article.details',
    path: `${PATH_PREFIX}/pages/:type/article/:docID`,
  },
  // Plans
  {
    name: 'keepital.plans',
    path: `${PATH_PREFIX}/plans`,
  },
  {
    name: 'keepital.plans.details',
    path: `${PATH_PREFIX}/plan/:docID/detail`,
  },
  {
    name: 'keepital.packages',
    path: `${PATH_PREFIX}/packages`,
  },
  {
    name: 'keepital.packages.details',
    path: `${PATH_PREFIX}/packages/:docID/detail`,
  },
  {
    name: 'keepital.settings',
    path: `${PATH_PREFIX}/settings`,
  },
];
